module.exports = __webpack_public_path__ + "img/d4.0d60bf3c.jpg";